import { useEffect, useState } from 'react';

// this is necessary for gatsby to build using the window object
const isBrowser = typeof window !== 'undefined';

const useMediaQuery = (query: string) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    if (isBrowser) {
      const media = window.matchMedia(query);
      if (media.matches !== matches) {
        setMatches(media.matches);
      }
      const listener = () => {
        setMatches(media.matches);
      };
      if (media.addEventListener) {
        media.addEventListener('change', listener);
      } else {
        // To support quirk on Safari versions prior to Safari 14
        media.addListener(listener);
      }
      return () => {
        if (media.removeEventListener) {
          media.removeEventListener('change', listener);
        } else {
          // To support quirk on Safari versions prior to Safari 14
          media.removeListener(listener);
        }
      };
    }
  }, [matches, query]);

  return matches;
};

export default useMediaQuery;
